import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/enrichment/',
)({
  beforeLoad: () => {
    throw redirect({ to: '/super-admin/enrichment/configuration' });
  },
});
